import { InjectionKey, ref } from '@vue/composition-api'

export type ErrorType = {
    name?: string[]
    tel?: string[]
    email?: string[]
    zip?: string[]
    address?: string[]
    construction?: string[]
    howto?: string[]
    ipad?: string[]
    shop?: string[]
    shop_other?: string[]
    date?: string[]
    time?: string[]
    question?: { [key: string]: string[] }
    important?: string[]
    request1?: string[]
    request2?: string[]
    request3?: string[]
    request_model1?: string[]
    request_model2?: string[]
    request_model3?: string[]
    request_other?: string[]
    privacy?: string[]
    first_time?: string[]
}

export default function store() {
    const name = ref<string[] | null>(null)
    const tel = ref<string[] | null>(null)
    const email = ref<string[] | null>(null)
    const zip = ref<string[] | null>(null)
    const address = ref<string[] | null>(null)
    const construction = ref<string[] | null>(null)
    const howto = ref<string[] | null>(null)
    const ipad = ref<string[] | null>(null)
    const shop = ref<string[] | null>(null)
    const shop_other = ref<string[] | null>(null)
    const date = ref<string[] | null>(null)
    const time = ref<string[] | null>(null)
    const question = ref<{ [key: string]: string[] }>({})
    const important = ref<string[] | null>(null)
    const request1 = ref<string[] | null>(null)
    const request2 = ref<string[] | null>(null)
    const request3 = ref<string[] | null>(null)
    const request_model1 = ref<string[] | null>(null)
    const request_model2 = ref<string[] | null>(null)
    const request_model3 = ref<string[] | null>(null)
    const request_other = ref<string[] | null>(null)
    const privacy = ref<string[] | null>(null)
    const first_time = ref<string[] | null>(null)

    return {
        // name
        get name() {
            return name
        },

        // tel
        get tel() {
            return tel
        },

        // email
        get email() {
            return email
        },

        // zip
        get zip() {
            return zip
        },

        // address
        get address() {
            return address
        },

        // construction
        get construction() {
            return construction
        },

        // howto
        get howto() {
            return howto
        },

        // ipad
        get ipad() {
            return ipad
        },

        // shop
        get shop() {
            return shop
        },

        // shop_other
        get shop_other() {
            return shop_other
        },

        // date
        get date() {
            return date
        },

        // time
        get time() {
            return time
        },

        // question
        get question() {
            return question
        },

        // important
        get important() {
            return important
        },

        // request1
        get request1() {
            return request1
        },

        // request2
        get request2() {
            return request2
        },

        // request3
        get request3() {
            return request3
        },

        // request_model1
        get request_model1() {
            return request_model1
        },

        // request_model2
        get request_model2() {
            return request_model2
        },

        // request_model3
        get request_model3() {
            return request_model3
        },

        // request_other
        get request_other() {
            return request_other
        },

        // privacy
        get privacy() {
            return privacy
        },

        // first_time
        get first_time() {
            return first_time
        },

        update(data: ErrorType) {
            if (data.name) {
                name.value = [...data.name]
            } else {
                name.value = null
            }
            if (data.tel) {
                tel.value = [...data.tel]
            } else {
                tel.value = null
            }
            if (data.email) {
                email.value = [...data.email]
            } else {
                email.value = null
            }
            if (data.zip) {
                zip.value = [...data.zip]
            } else {
                zip.value = null
            }
            if (data.address) {
                address.value = [...data.address]
            } else {
                address.value = null
            }
            if (data.construction) {
                construction.value = [...data.construction]
            } else {
                construction.value = null
            }
            if (data.howto) {
                howto.value = [...data.howto]
            } else {
                howto.value = null
            }
            if (data.ipad) {
                ipad.value = [...data.ipad]
            } else {
                ipad.value = null
            }
            if (data.shop) {
                shop.value = [...data.shop]
            } else {
                shop.value = null
            }
            if (data.shop_other) {
                shop_other.value = [...data.shop_other]
            } else {
                shop_other.value = null
            }
            if (data.date) {
                date.value = [...data.date]
            } else {
                date.value = null
            }
            if (data.time) {
                time.value = [...data.time]
            } else {
                time.value = null
            }
            if (data.question) {
                question.value = { ...data.question }
            } else {
                question.value = {}
            }
            if (data.important) {
                important.value = [...data.important]
            } else {
                important.value = null
            }
            if (data.request1) {
                request1.value = [...data.request1]
            } else {
                request1.value = null
            }
            if (data.request2) {
                request2.value = [...data.request2]
            } else {
                request2.value = null
            }
            if (data.request3) {
                request3.value = [...data.request3]
            } else {
                request3.value = null
            }
            if (data.request_model1) {
                request_model1.value = [...data.request_model1]
            } else {
                request_model1.value = null
            }
            if (data.request_model2) {
                request_model2.value = [...data.request_model2]
            } else {
                request_model2.value = null
            }
            if (data.request_model3) {
                request_model3.value = [...data.request_model3]
            } else {
                request_model3.value = null
            }
            if (data.request_other) {
                request_other.value = [...data.request_other]
            } else {
                request_other.value = null
            }
            if (data.privacy) {
                privacy.value = [...data.privacy]
            } else {
                privacy.value = null
            }
            if (data.first_time) {
                first_time.value = [...data.first_time]
            } else {
                first_time.value = null
            }
        },
    }
}

export type StoreType = ReturnType<typeof store>
export const StoreKey: InjectionKey<StoreType> = Symbol('ErrorType')
